"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.strongAspects = void 0;
var defs_1 = require("./defs");
var constants_1 = require("./constants");
var astro_utils_1 = require("./astro-utils");
var planets_power_1 = require("./planets-power");
var utils_1 = require("./utils");
var aspects_1 = require("./aspects");
function checkAspectObjects(a, obj1, obj2) {
    return (a.obj1 === obj1 && a.obj2 === obj2 ||
        a.obj1 === obj2 && a.obj2 === obj1);
}
function strongAspects(calc, nAspects) {
    var pp = (0, planets_power_1.planetsPower)(__assign(__assign({}, calc), { aspects: nAspects })).map(function (i) { return i.p; });
    var stdAspects = nAspects
        .filter(function (a) {
        return constants_1.majorAspects.includes(a.type) &&
            a.obj1 <= defs_1.ObjectType.Lilith &&
            a.obj2 <= defs_1.ObjectType.Lilith &&
            !(checkAspectObjects(a, defs_1.ObjectType.SouthNode, defs_1.ObjectType.NorthNode) ||
                checkAspectObjects(a, defs_1.ObjectType.Lilith, defs_1.ObjectType.NorthNode) ||
                checkAspectObjects(a, defs_1.ObjectType.Lilith, defs_1.ObjectType.SouthNode));
    });
    var addAspects = (0, aspects_1.houseAspects)(calc.objects, calc.houses, stdAspects.length);
    var aspects = __spreadArray(__spreadArray([], stdAspects, true), addAspects, true).map(function (a) { return ({
        type: a.type,
        obj1: a.obj1,
        obj2: a.obj2,
        lon1: a.lon1,
        lon2: a.lon2,
        orbise: a.orbise,
        realOrbise: a.realOrbise,
        weight: 0
    }); });
    var printAspects = function (title) {
    };
    var planetAspects = aspects.filter(function (a) { return a.obj1 <= defs_1.ObjectType.Pluto && a.obj2 <= defs_1.ObjectType.Pluto; });
    var hc = (0, astro_utils_1.getHouseControllers)(calc.houses);
    var houses = {};
    for (var p = defs_1.ObjectType.Sun; p <= defs_1.ObjectType.Pluto; p++) {
        houses[p] = (0, astro_utils_1.getObjectHouses)(calc.objects[p].lon, calc.houses, false);
    }
    {
        var f_1 = function (a, obj, lon) {
            if (Object
                .entries(constants_1.dispositors)
                .filter(function (i) { return i[1].includes(obj); })
                .map(function (i) { return +i[0]; })
                .includes((0, astro_utils_1.getSign)(lon))) {
                a.weight += 2;
            }
        };
        planetAspects.forEach(function (a) {
            f_1(a, a.obj1, a.lon2);
            f_1(a, a.obj2, a.lon1);
        });
        printAspects('2.1');
    }
    {
        var f_2 = function (a, obj1, obj2) {
            if ((0, utils_1.intersection)(hc[obj1], houses[obj2]).length) {
                a.weight += 2;
            }
        };
        planetAspects.forEach(function (a) {
            f_2(a, a.obj1, a.obj2);
            f_2(a, a.obj2, a.obj1);
        });
        printAspects('2.2');
    }
    {
        var f_3 = function (a, obj1, obj2) {
            var _a;
            if (obj2 >= defs_1.ObjectType.House1 && ((_a = hc[obj1]) === null || _a === void 0 ? void 0 : _a.includes(obj2 - defs_1.ObjectType.House1))) {
                a.weight += 1;
            }
        };
        aspects.forEach(function (a) {
            f_3(a, a.obj1, a.obj2);
            f_3(a, a.obj2, a.obj1);
        });
        printAspects('2.3');
    }
    {
        var f_4 = function (a, obj) {
            var asps = aspects.filter(function (asp) { return asp.type === a.type && (checkAspectObjects(asp, obj, defs_1.ObjectType.Lilith) ||
                checkAspectObjects(asp, obj, defs_1.ObjectType.SouthNode) ||
                checkAspectObjects(asp, obj, defs_1.ObjectType.NorthNode)); });
            if (asps.length) {
                a.weight += 1;
            }
        };
        planetAspects.forEach(function (a) {
            f_4(a, a.obj2);
            f_4(a, a.obj1);
        });
        printAspects('2.4');
    }
    {
        var f_5 = function (a, obj1, obj2) {
            if ((0, utils_1.intersection)(houses[obj2], constants_1.significators[obj1]).length) {
                a.weight += 2;
            }
        };
        planetAspects.forEach(function (a) {
            f_5(a, a.obj1, a.obj2);
            f_5(a, a.obj2, a.obj1);
        });
        printAspects('2.5');
    }
    {
        var f_6 = function (a, obj1, obj2) {
            var _a;
            if (obj2 >= defs_1.ObjectType.House1 && ((_a = constants_1.significators[obj1]) === null || _a === void 0 ? void 0 : _a.includes(obj2 - defs_1.ObjectType.House1))) {
                a.weight += 1;
            }
        };
        aspects.forEach(function (a) {
            f_6(a, a.obj1, a.obj2);
            f_6(a, a.obj2, a.obj1);
        });
        printAspects('2.6');
    }
    {
        var f_7 = function (a, obj1, obj2) {
            if ((0, utils_1.intersection)(hc[obj1], constants_1.significators[obj2]).length) {
                a.weight += 1;
                return true;
            }
            return false;
        };
        planetAspects.forEach(function (a) {
            if (!f_7(a, a.obj1, a.obj2)) {
                f_7(a, a.obj2, a.obj1);
            }
        });
        printAspects('2.7');
    }
    planetAspects.forEach(function (a) {
        if (a.realOrbise === 0) {
            a.weight += 2;
        }
    });
    printAspects('2.8');
    planetAspects.forEach(function (a) {
        if (pp.includes(a.obj1) && pp.includes(a.obj2)) {
            a.weight += 1;
        }
    });
    printAspects('2.9');
    return aspects
        .filter(function (a) { return a.weight > 0; })
        .sort(function (a, b) {
        return b.weight - a.weight ||
            a.obj1 - b.obj1 ||
            a.type - b.type ||
            a.obj2 - b.obj2;
    });
}
exports.strongAspects = strongAspects;
